import styled from 'styled-components';
import React, { useRef, useState } from 'react';
import { strings } from '/imports/strings';
import { capitalize, isMobile } from '/imports/utils';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { Button } from '/imports/ui/Button';

export const Oauth2ThankYouPageStyled = styled(SignedOutPageStyled)`
`;

/** Post-OAuth2 page that deep-links back into the native app to finish authorization. */
export const Oauth2ThankYouPage = () => {
  const params = new URLSearchParams(location.search);
  const state = JSON.parse(window.atob(params.get('state') || '') || '{}');
  const oauthService = state.service || '';
  const anchor = useRef<HTMLAnchorElement>(null);
  const [complete, setComplete] = useState(false);
  return (
    <Oauth2ThankYouPageStyled className="page">
      <div className="wrapper">
        <div className="inner-wrapper">
          <div><Logo size={isMobile() ? 3 : 5} /></div>
          {
            complete ?
              <div>{strings.ThankYouForUsingAuth(capitalize(oauthService))}</div>
              :
              <div>
                <div>{strings.AlmostDoneClickButtonBelowToCompleteAuth()}</div>
                <div>
                  <a ref={anchor} href={`luminia.io://${window.btoa(window.location.href)}`} onClick={() => setComplete(true)}>
                    <Button>{strings.CompleteAuthorization()}</Button>
                  </a>
                </div>
              </div>
          }
        </div>
      </div>
      <PublicFooter />
    </Oauth2ThankYouPageStyled>
  );
};